import styled from 'styled-components';



export const ImageBenefitsIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
